"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
exports.getIconPath = getIconPath;
const static_hashes_json_1 = __importDefault(require("@aurora/shared-generated/static-hashes.json"));
const EnumHelper_1 = require("@aurora/shared-utils/helpers/objects/EnumHelper");
const UrlHelper_1 = require("@aurora/shared-utils/helpers/urls/UrlHelper/UrlHelper");
const enums_1 = __importDefault(require("./public/static/graphics/processed/enums"));
const hash = process.env.NODE_ENV === 'test' ? 'h4x' : static_hashes_json_1.default.graphics;
const basePath = (0, UrlHelper_1.prefixStaticAsset)(`/static/graphics/processed/${hash}`);
function getIconPath(icon) {
    // If this icon is actually a provided icon (Khoros controls), we can go ahead and build the url for it...
    const isOurIcon = (0, EnumHelper_1.getAsEnum)(icon, enums_1.default, null) !== null;
    if (isOurIcon) {
        return `${basePath}/${icon}.svg#${icon}`;
    }
    else {
        // Assume the icon is a third-party link and return it as-is
        return icon;
    }
}
// Re-export prevents needing to go thru every file and import the enum directly...
var enums_2 = require("./public/static/graphics/processed/enums");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(enums_2).default; } });
//# sourceMappingURL=icons.js.map